import { createLookupTable } from '../utils';

const statuses = {
  low: 'success',
  medium: 'info',
  high: 'warning',
  critical: 'error',
} as const;

export type TaskPriorityLabel = keyof typeof taskPriorityTable;
export const taskPriorityTable = createLookupTable(statuses, 'taskPriority');
